<template>
<div class="page-delivery-and-payment">
  <tabs-page title="Доставка и оплата" :tabs="activeTabs"></tabs-page>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import TabsPage from '@/components/pages/TabsPage'
import DeliveryInfo from '@/components/delivery-and-payment/DeliveryInfo'
import PaymentInfo from '@/components/delivery-and-payment/PaymentInfo'
import GuaranteeInfo from '@/components/delivery-and-payment/GuaranteeInfo'
import InjectsSeo from '@/mixins/InjectsSeo'

export default {
  components: {
    TabsPage,
  },

  mixins: [InjectsSeo],

  metaInfo() {
    return this.getMetaInfoFromSettings(this.pageSeo)
  },

  computed: {
    ...mapGetters({
      delivery: 'settings/deliveryPaymentsDelivery',
      payments: 'settings/deliveryPaymentsPayments',
      guarantee: 'settings/deliveryPaymentsGuarantee',
      pageSeo: 'settings/deliveryPaymentsSeo',
    }),

    activeTabs() {
      const tabs = this.tabs.filter(tab => this[tab.name].display);

      if (tabs.length !== 0) {
        tabs[0].active = true;
      }

      return tabs;
    }
  },

  data() {
    return {
      tabs: [
        {
          name: 'delivery',
          component: DeliveryInfo,
          label: 'Доставка',
          active: false,
        },
        {
          name: 'payments',
          component: PaymentInfo,
          label: 'Оплата',
          active: false,
        },
        {
          name: 'guarantee',
          component: GuaranteeInfo,
          label: 'Гарантия',
          active: false,
        },
      ]
    }
  }
}
</script>
